import React, { Component } from "react";

export default class PageContact extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--about c-text'}>
			    			    		
		    		<div className="l-grid">
						
						<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
						
							{block.text &&
								<div className="scope-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
							}
							
						</div>
		    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
